import React from "react";
import { cn } from "../../../../utils/classnames";
import { ARROW_RIGHT_WHITE_ICON } from "../constants";
import { useBookingEditText } from "../text";

const ActionButtons = ({ getTypographyClass, onReviewChanges, isSimulatingReview, onDiscardClick }) => {
    const { t } = useBookingEditText();

    return (
        <div className="tw:flex tw:flex-col-reverse tw:lg:flex-row tw:items-center tw:justify-center tw:gap-2">
            <button type="button" onClick={onDiscardClick}>
                <div
                    className={cn(
                        "tw:flex tw:font-normal tw:items-center tw:justify-center tw:h-[45px] tw:w-[350px] tw:lg:w-[300px] tw:rounded-[5px] tw:bg-[#f3f3f3] tw:text-[#282828] tw:font-hanken-grotesk",
                        getTypographyClass(14)
                    )}
                >
                    {t("editBooking.BookingEditPage.button.discardEdit")}
                </div>
            </button>
            <button
                type="button"
                onClick={onReviewChanges}
                disabled={isSimulatingReview}
            >
                <div
                    className={cn(
                        "tw:h-[45px] tw:w-[350px] tw:lg:w-[300px] tw:rounded-[5px] tw:bg-[#282828] tw:text-white tw:flex tw:items-center tw:justify-center tw:gap-2 tw:font-hanken-grotesk",
                        getTypographyClass(14),
                        "tw:!font-[700]"
                    )}
                >
                    {isSimulatingReview ? t("editBooking.BookingEditPage.button.reviewing") : t("editBooking.BookingEditPage.button.reviewChanges")}
                    <img
                        src={ARROW_RIGHT_WHITE_ICON}
                        alt="Arrow Right Icon"
                        className="tw:inline"
                    />
                </div>
            </button>
        </div>
    );
};

export default ActionButtons;
